import { registerSW } from 'virtual:pwa-register';

registerSW({
  // https://vite-pwa-org.netlify.app/guide/auto-update.html
  immediate: true,

  onRegisteredSW: (swScriptUrl, registration) => {
    console.log(`Registered service worker : ${swScriptUrl} : ${registration?.scope}`);

    // https://vite-pwa-org.netlify.app/guide/periodic-sw-updates.html
    if (!registration) return;
    setInterval(async () => {
      if (!(!registration.installing && navigator)) {
        return;
      }

      if ('connection' in navigator && !navigator.onLine) {
        return;
      }

      const resp = await fetch(swScriptUrl, {
        cache: 'no-store',
        headers: { cache: 'no-store', 'cache-control': 'no-cache' }
      });

      if (resp?.status === 200) {
        console.log(`${new Date().toLocaleString()} : Updating service worker`);
        await registration.update();
      } else {
        console.error(`Unable to update service worker : ${JSON.stringify(resp)}`);
      }
    }, 60000);
  },
  onNeedRefresh: () => {
    console.log(`Refresh required`);
  },
  onRegisterError: (error) => {
    console.error(`Error registering service worker : ${error}`);
  }
});
